module.exports = __webpack_public_path__ + "img/icon_social3.87d39cca.png";